import "../styles/header.css";

/**
 * Header displays the Rapid City Transportation logo.
 *
 * @returns {JSX.Element}
 */
const Header = () => {
    return (
        <div className="header">
            <img
                src="/images/rct-logo.png"
                alt="Rapid City Transportation Logo"
                className="header-logo"
            />
        </div>
    );
};

export default Header;
